/* run once per page even if the loader snippet is rendered by several sections (speed 2026-11-02) */
if (!window.__skSpectraOnce) { window.__skSpectraOnce = true;
  /* build: spectra hero orbit contained (no bleed) — 2026-05-28 */
  // Live EST clock — uses America/New_York timezone (auto-handles EST/EDT)
  function pad(n){ return String(n).padStart(2,'0'); }
  function tick(){
    var el = document.getElementById('utc');
    if (!el) return;
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      hour12: false,
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    }).formatToParts(new Date());
    var h = '00', m = '00', s = '00';
    parts.forEach(function(p){
      if (p.type === 'hour')   h = p.value === '24' ? '00' : p.value;
      if (p.type === 'minute') m = p.value;
      if (p.type === 'second') s = p.value;
    });
    el.textContent = h + ':' + m + ':' + s;
  }
  tick(); setInterval(tick, 1000);

  // ─── Live price matrix (mirror of the live store variants) ───────
  // term × billing × addon → price in dollars
  var PRICES = {
    '12_monthly_no':    300.00,  '12_monthly_qs':    499.00,
    '12_quarterly_no':  855.00,  '12_quarterly_qs': 1054.00,
    '12_annual_no':    3240.00,  '12_annual_qs':    3439.00,
    '24_monthly_no':    269.00,  '24_monthly_qs':    468.00,
    '24_quarterly_no':  766.65,  '24_quarterly_qs':  965.65,
    '24_annual_no':    2905.20,  '24_annual_qs':    3104.20,
    '36_monthly_no':    219.00,  '36_monthly_qs':    418.00,
    '36_quarterly_no':  624.15,  '36_quarterly_qs':  823.15,
    '36_annual_no':    2365.20,  '36_annual_qs':    2564.20
  };
  var TERM_NAMES    = { '12': '· 12-month', '24': '· 24-month', '36': '· 36-month' };
  var BILLING_NAMES = { 'monthly': '· Monthly', 'quarterly': '· Quarterly', 'annual': '· Annual' };
  var ADDON_NAMES   = { 'no': '· None', 'qs': '· QuickSite' };
  var BILLING_PER   = { 'monthly': '/ month', 'quarterly': '/ quarter', 'annual': '/ year' };
  var BILLING_LABEL = { 'monthly': 'month', 'quarterly': 'quarter', 'annual': 'year' };

  function fmtPrice(n) {
    return '$' + (n % 1 === 0
      ? n.toLocaleString('en-US')
      : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  }

  function getSelected(name) {
    var el = document.querySelector('input[name="' + name + '"]:checked');
    return el ? el.value : null;
  }

  function updatePrice() {
    var term    = getSelected('term');
    var billing = getSelected('billing');
    var addon   = getSelected('addon');
    var key     = term + '_' + billing + '_' + addon;
    var price   = PRICES[key];
    if (price == null) return;

    // Main price block
    document.getElementById('priceCurrent').textContent = fmtPrice(price);
    document.getElementById('pricePer').textContent     = BILLING_PER[billing];

    // Savings vs the matching 12-month variant (same billing + add-on)
    var basePrice = PRICES['12_' + billing + '_' + addon];
    var save = document.getElementById('priceSavings');
    if (term !== '12' && basePrice && price < basePrice) {
      var pct = Math.round((basePrice - price) / basePrice * 100);
      save.textContent = 'Save ' + pct + '% vs 12-mo';
    } else {
      save.textContent = '';
    }

    // Sticky mobile CTA
    var sp = document.getElementById('stickyPrice');
    var sn = document.getElementById('stickyPriceNote');
    if (sp) sp.textContent = fmtPrice(price);
    if (sn) sn.textContent = '/ ' + BILLING_LABEL[billing] + ' · ' + term + '-month plan';

    // Legend labels
    document.getElementById('termName').textContent    = TERM_NAMES[term] || '';
    document.getElementById('billingName').textContent = BILLING_NAMES[billing] || '';
    document.getElementById('addonName').textContent   = ADDON_NAMES[addon] || '';
  }

  document.querySelectorAll('input[name="term"], input[name="billing"], input[name="addon"]').forEach(function(input){
    input.addEventListener('change', updatePrice);
  });
  updatePrice();

  // Sticky CTA: show after the user scrolls past the buy box
  var sticky = document.getElementById('stickyCta');
  var buyBox = document.querySelector('.buy');
  if (sticky && buyBox && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        // When buy box is OUT of view, reveal sticky CTA
        sticky.classList.toggle('is-visible', !e.isIntersecting);
        sticky.setAttribute('aria-hidden', e.isIntersecting ? 'true' : 'false');
      });
    }, { threshold: 0 });
    io.observe(buyBox);
  }

  // Quantity buttons
  document.querySelectorAll('.qty__btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var input = document.getElementById('qty-input');
      var step  = parseInt(btn.dataset.qty, 10);
      var next  = Math.max(1, parseInt(input.value, 10) + step);
      input.value = next;
    });
  });

  // ───────────── Hub-and-spoke network canvas ─────────────
  // 1 central business node connected to 100 directory nodes.
  // 8 of those are labeled platforms (GBP, Apple Maps, Facebook…), the rest are
  // unlabeled — representing the long tail of 100+ smaller directories.
  // Pulses occasionally fire from the hub outward, visualizing data sync.
  // The hub is draggable — grab it and the whole cloud follows.
  (function(){
    var canvas = document.getElementById('nodeCanvas');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0, restX = 0, restY = 0, maxR = 0;
    var hubX = 0, hubY = 0;            // smoothed hub position (drawn)
    var targetX = 0, targetY = 0;      // cursor target while dragging
    var isDragging = false;
    var hoverHub = false;
    var HUB_HIT = 28; // px hit radius for grab

    function resize(){
      var r = canvas.parentNode.getBoundingClientRect();
      W = Math.round(r.width); H = Math.round(r.height);
      canvas.width  = Math.round(W * dpr);
      canvas.height = Math.round(H * dpr);
      canvas.style.width  = W + 'px';
      canvas.style.height = H + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      restX = W / 2;
      restY = H / 2;
      maxR = Math.min(restX, restY) - 70;
      if (!isDragging) { hubX = restX; hubY = restY; }
    }
    resize();
    window.addEventListener('resize', resize);

    function pointInHub(x, y) {
      var dx = x - hubX, dy = y - hubY;
      return dx*dx + dy*dy < HUB_HIT * HUB_HIT;
    }
    function eventXY(e){
      var r = canvas.getBoundingClientRect();
      var p = (e.touches && e.touches[0]) || e;
      return { x: p.clientX - r.left, y: p.clientY - r.top };
    }

    canvas.addEventListener('mousemove', function(e){
      var p = eventXY(e);
      if (isDragging) {
        targetX = p.x; targetY = p.y;
      } else {
        var over = pointInHub(p.x, p.y);
        if (over !== hoverHub) {
          hoverHub = over;
          canvas.style.cursor = over ? 'grab' : 'default';
        }
      }
    }, { passive: true });
    canvas.addEventListener('mousedown', function(e){
      var p = eventXY(e);
      if (pointInHub(p.x, p.y)) {
        isDragging = true;
        targetX = p.x; targetY = p.y;
        canvas.style.cursor = 'grabbing';
        e.preventDefault();
      }
    });
    window.addEventListener('mouseup', function(){
      if (isDragging) {
        isDragging = false;
        canvas.style.cursor = hoverHub ? 'grab' : 'default';
      }
    });
    canvas.addEventListener('touchstart', function(e){
      var p = eventXY(e);
      if (pointInHub(p.x, p.y)) {
        isDragging = true;
        targetX = p.x; targetY = p.y;
        e.preventDefault();
      }
    }, { passive: false });
    canvas.addEventListener('touchmove', function(e){
      if (!isDragging) return;
      var p = eventXY(e);
      targetX = p.x; targetY = p.y;
      e.preventDefault();
    }, { passive: false });
    window.addEventListener('touchend', function(){ isDragging = false; });

    // 3-tier directory roster — names match the auto-scrolling rails below.
    // Tier 1 = primary (largest, brightest, full label), Tier 2 = secondary,
    // Tier 3 = niche (smallest labeled). Below tier 3 = unlabeled long-tail dots.
    var PLATFORMS = [
      // Tier 1 — the household-name maps & review platforms
      { name: 'Google Business', tier: 1 },
      { name: 'Apple Maps',      tier: 1 },
      { name: 'Yelp',            tier: 1 },
      { name: 'Facebook',        tier: 1 },
      { name: 'Bing Places',     tier: 1 },
      { name: 'TripAdvisor',     tier: 1 },
      { name: 'Foursquare',      tier: 1 },
      { name: 'Waze',            tier: 1 },
      // Tier 2 — well-known but secondary
      { name: 'Nextdoor',        tier: 2 },
      { name: 'BBB',             tier: 2 },
      { name: 'Trustpilot',      tier: 2 },
      { name: 'Yellow Pages',    tier: 2 },
      { name: 'MapQuest',        tier: 2 },
      { name: 'Yahoo Local',     tier: 2 },
      { name: 'Uber Eats',       tier: 2 },
      { name: 'DoorDash',        tier: 2 },
      { name: 'OpenTable',       tier: 2 },
      { name: 'Healthgrades',    tier: 2 },
      // Tier 3 — niche / long-tail directories
      { name: 'Citysearch',      tier: 3 },
      { name: 'Manta',           tier: 3 },
      { name: 'Hotfrog',         tier: 3 },
      { name: 'MerchantCircle',  tier: 3 },
      { name: 'Glassdoor',       tier: 3 },
      { name: 'Angi',            tier: 3 },
      { name: 'Thumbtack',       tier: 3 },
      { name: 'Avvo',            tier: 3 },
      { name: 'Grubhub',         tier: 3 },
      { name: 'Resy',            tier: 3 },
      { name: 'Vitals',          tier: 3 },
      { name: 'Indeed',          tier: 3 }
    ];
    var NUM_NODES = 160;       // 30 labeled + 130 long-tail
    var STIFFNESS = 0.04;      // spring strength
    var DAMPING   = 0.88;      // velocity decay per frame (rubber-band feel)

    // Each node has x/y + velocity, a tier (0 = unlabeled), an optional label,
    // and a render radius. Visual hierarchy comes from size/glow, not from
    // position — every node scatters fully across the available area so the
    // network reads as an organic web rather than concentric rings.
    var nodes = [];
    for (var i = 0; i < NUM_NODES; i++) {
      var p = PLATFORMS[i];
      var tier = p ? p.tier : 0;
      // Fully random angle for everyone — no even distribution.
      var ang = Math.random() * Math.PI * 2;
      // Sqrt-distributed radius = even area density (no center-clumping).
      // Each tier occupies the same wide range so they intermix spatially.
      var rdN;
      if      (tier === 1) rdN = 0.22 + Math.sqrt(Math.random()) * 0.62;  // 0.22–0.84
      else if (tier === 2) rdN = 0.25 + Math.sqrt(Math.random()) * 0.65;  // 0.25–0.90
      else if (tier === 3) rdN = 0.28 + Math.sqrt(Math.random()) * 0.66;  // 0.28–0.94
      else                  rdN = 0.18 + Math.sqrt(Math.random()) * 0.80; // 0.18–0.98
      var rd = rdN * maxR;
      var r;
      if      (tier === 1) r = 6.0;
      else if (tier === 2) r = 4.5;
      else if (tier === 3) r = 3.4;
      else                  r = 1.4 + Math.random() * 1.4;
      nodes.push({
        x:  hubX + Math.cos(ang) * rd,
        y:  hubY + Math.sin(ang) * rd,
        vx: 0, vy: 0,
        restDistanceN: rdN,
        tier: tier,
        isPlatform: tier > 0,
        label: p ? p.name : null,
        r: r,
        phase: Math.random() * Math.PI * 2
      });
    }

    // Pulses ride along the live spoke from hub to a specific node — so even
    // while a node is swinging from a drag, the pulse tracks the spoke.
    var pulses = [];
    function spawnPulse(){
      if (pulses.length > 6) return;
      pulses.push({
        nodeIdx:  Math.floor(Math.random() * nodes.length),
        progress: 0,
        speed:    0.014 + Math.random() * 0.012
      });
    }
    setInterval(spawnPulse, 280);

    // ── Starfield: fixed scatter behind everything, twinkles + parallax ──
    // Each star stores normalized 0–1 canvas coords + a twinkle phase/speed.
    // Stars drift opposite to hub drag at 12% intensity for depth illusion.
    var STAR_COUNT = 280;
    var stars = [];
    for (var si = 0; si < STAR_COUNT; si++) {
      stars.push({
        u: Math.random(),
        v: Math.random(),
        r: 0.35 + Math.random() * Math.random() * 1.4,   // mostly tiny, a few brighter
        phase: Math.random() * Math.PI * 2,
        speed: 0.3 + Math.random() * 1.6,
        warm: Math.random() < 0.08                        // ~8% gold-tinted "stars"
      });
    }

    function tick(now){
      // Lerp hub toward cursor (drag) or back to rest (release)
      if (isDragging) {
        hubX += (targetX - hubX) * 0.22;
        hubY += (targetY - hubY) * 0.22;
      } else {
        hubX += (restX - hubX) * 0.07;
        hubY += (restY - hubY) * 0.07;
      }

      ctx.clearRect(0, 0, W, H);
      var t = now / 1000;
      var i, n, dx, dy, d, stretch, fx, fy, restDistance, pulseAmt, alpha;

      // ── Starfield (drawn first, behind everything else) ────────────────
      // Parallax: stars drift opposite to hub drag at low intensity → depth.
      var sParX = -(hubX - restX) * 0.12;
      var sParY = -(hubY - restY) * 0.12;
      // Subtle warm glow at viewport center to suggest the hub's light pool
      var coreGrad = ctx.createRadialGradient(restX, restY, 0, restX, restY, Math.min(W, H) * 0.55);
      coreGrad.addColorStop(0,   'rgba(146, 188, 221, 0.05)');
      coreGrad.addColorStop(0.4, 'rgba(146, 188, 221, 0.02)');
      coreGrad.addColorStop(1,   'rgba(146, 188, 221, 0)');
      ctx.fillStyle = coreGrad;
      ctx.fillRect(0, 0, W, H);

      for (var sk = 0; sk < stars.length; sk++) {
        var s = stars[sk];
        var twinkle = Math.sin(t * s.speed + s.phase) * 0.4 + 0.6;
        var sx = s.u * W + sParX;
        var sy = s.v * H + sParY;
        // Wrap so parallax never reveals empty edges
        if (sx < 0)  sx += W; else if (sx > W) sx -= W;
        if (sy < 0)  sy += H; else if (sy > H) sy -= H;
        if (s.warm) {
          ctx.fillStyle = 'rgba(235, 217, 168, ' + (twinkle * 0.85) + ')';
          ctx.shadowColor = '#e0ecf7'; ctx.shadowBlur = s.r > 0.9 ? 4 : 0;
        } else {
          ctx.fillStyle = 'rgba(220, 230, 240, ' + (twinkle * 0.7) + ')';
          ctx.shadowBlur = 0;
        }
        ctx.beginPath();
        ctx.arc(sx, sy, s.r, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.shadowBlur = 0;

      // ── Physics: each node is a mass on a spring tethered to the hub ──
      // Spring rest length is multiplied by scrollBloom so nodes spread
      // outward as the user scrolls through the hero (cinematic bloom).
      for (i = 0; i < nodes.length; i++) {
        n = nodes[i];
        restDistance = n.restDistanceN * maxR * (window.scrollBloom || 1); // scroll-tied bloom
        dx = n.x - hubX;
        dy = n.y - hubY;
        d  = Math.sqrt(dx*dx + dy*dy);
        if (d > 0.001) {
          stretch = d - restDistance;          // + = stretched, − = compressed
          fx = -(dx / d) * stretch * STIFFNESS;
          fy = -(dy / d) * stretch * STIFFNESS;
          n.vx += fx;
          n.vy += fy;
        }
        n.vx *= DAMPING;
        n.vy *= DAMPING;
        n.x  += n.vx;
        n.y  += n.vy;
      }

      // ── Hub spokes — only connections drawn now. Spoke weight + brightness
      //    scales with tier so the network has visible hierarchy.
      for (i = 0; i < nodes.length; i++) {
        n = nodes[i];
        if      (n.tier === 1) { alpha = 0.45; ctx.lineWidth = 1.2; }
        else if (n.tier === 2) { alpha = 0.32; ctx.lineWidth = 1.0; }
        else if (n.tier === 3) { alpha = 0.20; ctx.lineWidth = 0.7; }
        else                    { alpha = 0.08; ctx.lineWidth = 0.4; }
        ctx.strokeStyle = 'rgba(146, 188, 221, ' + alpha + ')';
        ctx.beginPath();
        ctx.moveTo(hubX, hubY);
        ctx.lineTo(n.x, n.y);
        ctx.stroke();
      }

      // ── Pulses (data sync travelling along the spoke) ─────────────────
      ctx.shadowColor = '#f5ebc8';
      ctx.shadowBlur = 10;
      for (var p = pulses.length - 1; p >= 0; p--) {
        var pl = pulses[p];
        pl.progress += pl.speed;
        if (pl.progress >= 1) { pulses.splice(p, 1); continue; }
        var nT = nodes[pl.nodeIdx];
        var px = hubX + (nT.x - hubX) * pl.progress;
        var py = hubY + (nT.y - hubY) * pl.progress;
        var fadeIn = Math.min(1, pl.progress * 6);
        ctx.fillStyle = 'rgba(245, 235, 200, ' + (0.95 * fadeIn) + ')';
        ctx.beginPath();
        ctx.arc(px, py, 2.2, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.shadowBlur = 0;

      // ── Outer directory nodes ─────────────────────────────────────────
      // Render in two passes so labels never overlap node circles.
      // First pass: dots (with tier-specific glow + size).
      for (i = 0; i < nodes.length; i++) {
        n = nodes[i];
        pulseAmt = Math.sin(t + n.phase) * 0.25 + 0.75;
        if (n.tier === 1) {
          ctx.shadowColor = '#92bcdd'; ctx.shadowBlur = 14;
          ctx.fillStyle = 'rgba(245, 235, 200, ' + pulseAmt + ')';
        } else if (n.tier === 2) {
          ctx.shadowColor = '#92bcdd'; ctx.shadowBlur = 9;
          ctx.fillStyle = 'rgba(240, 215, 165, ' + (pulseAmt * 0.92) + ')';
        } else if (n.tier === 3) {
          ctx.shadowColor = '#4c7197'; ctx.shadowBlur = 5;
          ctx.fillStyle = 'rgba(146, 188, 221, ' + (pulseAmt * 0.85) + ')';
        } else {
          ctx.shadowBlur = 0;
          ctx.fillStyle = 'rgba(160, 134, 73, ' + (pulseAmt * 0.55) + ')';
        }
        ctx.beginPath();
        ctx.arc(n.x, n.y, n.r, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.shadowBlur = 0;

      // Second pass: labels (only for tiered nodes). Font size scales by tier.
      // A subtle dark stroke behind the text makes labels readable on top of
      // any spoke or background dot.
      for (i = 0; i < nodes.length; i++) {
        n = nodes[i];
        if (n.tier === 0 || !n.label) continue;
        var fontSize, color;
        if      (n.tier === 1) { fontSize = 11; color = 'rgba(245, 235, 200, 0.95)'; }
        else if (n.tier === 2) { fontSize = 10; color = 'rgba(240, 215, 165, 0.85)'; }
        else                   { fontSize =  9; color = 'rgba(146, 188, 221, 0.72)'; }
        ctx.font = fontSize + 'px JetBrains Mono, ui-monospace, monospace';
        ctx.lineWidth = 3;
        ctx.strokeStyle = 'rgba(7, 8, 12, 0.85)';
        ctx.lineJoin = 'round';
        ctx.strokeText(n.label, n.x + n.r + 5, n.y - n.r - 2);
        ctx.fillStyle = color;
        ctx.fillText(n.label, n.x + n.r + 5, n.y - n.r - 2);
      }

      // Hub — drawn last so it sits on top of every spoke.
      // Visual emphasis grows on hover/drag so user knows it's interactive.
      var hubBreathe = Math.sin(t * 1.4) * 0.18 + 0.82;
      var emphasis = isDragging ? 1.15 : (hoverHub ? 1.07 : 1.0);
      var ringR = 18 + (hoverHub ? 4 : 0) + (isDragging ? 6 : 0);

      // Outer ring (grows on hover/drag)
      ctx.strokeStyle = isDragging
        ? 'rgba(245, 235, 200, 0.85)'
        : (hoverHub ? 'rgba(146, 188, 221, 0.78)' : 'rgba(146, 188, 221, 0.55)');
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.arc(hubX, hubY, ringR, 0, Math.PI * 2);
      ctx.stroke();

      // Glow
      ctx.shadowColor = '#f5ebc8';
      ctx.shadowBlur = 28 + (isDragging ? 10 : 0);
      ctx.fillStyle = 'rgba(255, 250, 230, ' + hubBreathe + ')';
      ctx.beginPath();
      ctx.arc(hubX, hubY, 9 * emphasis, 0, Math.PI * 2);
      ctx.fill();
      ctx.shadowBlur = 0;

      // Inner mark
      ctx.fillStyle = 'rgba(60, 64, 72, 0.9)';
      ctx.beginPath();
      ctx.arc(hubX, hubY, 3 * emphasis, 0, Math.PI * 2);
      ctx.fill();

      // Hub label
      ctx.fillStyle = 'rgba(245, 235, 200, 0.95)';
      ctx.font = '10px JetBrains Mono, ui-monospace, monospace';
      ctx.textAlign = 'center';
      ctx.fillText(isDragging ? 'DRAGGING…' : 'YOUR BUSINESS', hubX, hubY + 38);
      ctx.textAlign = 'start';

      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  })();

  // ═══ Statement word-light reveal on scroll ═══
  // Recursively wraps every text node in the statement in <span class="word">;
  // lights them up sequentially as the section scrolls. Robust to richtext
  // <p><em>...</em>...</p> structures and the flat text + <em> structure.
  // Init runs after window load (layout settled). Listens to scroll AND
  // resize. IntersectionObserver kicks an extra paint when section first
  // enters view, so even if scroll-listener timing is off, words still light.
  function initSpectraStatement() {
    var s = document.getElementById('statement');
    if (!s) return;
    if (s.dataset.spectraInit === '1') return; // idempotent
    s.dataset.spectraInit = '1';

    function wrapAllText(root) {
      var textNodes = [];
      (function walk(node) {
        Array.from(node.childNodes).forEach(function(child) {
          if (child.nodeType === 3) {
            if (child.textContent.trim().length) textNodes.push(child);
          } else if (child.nodeType === 1) {
            if (child.classList && child.classList.contains('statement__sig')) return;
            // Don't word-wrap <em> accents — keeps the gold gradient intact
            // and accent words always visible (no dim/lit cycle on them).
            if (child.tagName === 'EM') return;
            walk(child);
          }
        });
      })(root);
      textNodes.forEach(function(tn) {
        var frag = document.createDocumentFragment();
        tn.textContent.split(/(\s+)/).forEach(function(w) {
          if (/^\s+$/.test(w)) {
            frag.appendChild(document.createTextNode(w));
          } else if (w.length) {
            var span = document.createElement('span');
            span.className = 'word';
            span.textContent = w;
            frag.appendChild(span);
          }
        });
        if (tn.parentNode) tn.parentNode.replaceChild(frag, tn);
      });
    }
    wrapAllText(s);

    var words = s.querySelectorAll('.word');
    if (!words.length) return;
    var section = s.closest('.chapter') || s.parentElement;

    function paint() {
      if (!section) return;
      var rect = section.getBoundingClientRect();
      var totalH = section.offsetHeight - window.innerHeight;
      var p;
      if (totalH > 0) {
        p = -rect.top / totalH;
      } else {
        // Short section — light by visibility within the viewport
        var srect = s.getBoundingClientRect();
        p = 1 - (srect.top + srect.height * 0.3) / (window.innerHeight * 0.9);
      }
      p = Math.max(0, Math.min(1, p));
      var n = Math.floor(p * words.length);
      // Always light at least the first word once the section enters view
      if (rect.top < window.innerHeight && rect.bottom > 0 && n < 1) n = 1;
      words.forEach(function(w, i) { w.classList.toggle('is-lit', i <= n); });
    }

    window.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint, { passive: true });

    // Kick a paint when section first enters view (handles initial state)
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) paint();
      }, { threshold: 0 });
      io.observe(section);
    }

    // Initial paint after layout settles
    requestAnimationFrame(function(){ requestAnimationFrame(paint); });
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initSpectraStatement();
  } else {
    window.addEventListener('DOMContentLoaded', initSpectraStatement);
  }
  // Also re-init in case section gets dynamically replaced (Shopify customizer)
  document.addEventListener('shopify:section:load', initSpectraStatement);

  // ═══ Counters: count up when entering view ═══
  (function() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        el.classList.add('is-in');
        var to = parseFloat(el.dataset.to || '0');
        var dur = 1800;
        var t0 = null;
        var span = el.querySelector('.num');
        function frame(t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          var v = Math.floor(eased * to);
          span.textContent = v;
          if (p < 1) requestAnimationFrame(frame);
          else span.textContent = to;
        }
        requestAnimationFrame(frame);
        io.unobserve(el);
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('[data-counter]').forEach(function(el) { io.observe(el); });
  })();

  // ═══ Animated US map — directory hubs + sync paths ═══
  (function() {
    var c = document.getElementById('mapCanvas');
    if (!c) return;
    var ctx = c.getContext('2d');
    var W = 0, H = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
    function resize() { var r = c.getBoundingClientRect(); W = r.width; H = r.height; c.width = W * dpr; c.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
    resize(); window.addEventListener('resize', resize);

    // Procedural US silhouette dots
    var dotMap = [];
    function inUS(u, v) {
      function inEll(cx, cy, rx, ry) { var dx = (u - cx) / rx, dy = (v - cy) / ry; return dx * dx + dy * dy < 1; }
      if (inEll(0.10, 0.55, 0.07, 0.30)) return true;
      if (inEll(0.13, 0.40, 0.06, 0.18)) return true;
      if (inEll(0.30, 0.55, 0.18, 0.30)) return true;
      if (inEll(0.35, 0.40, 0.20, 0.18)) return true;
      if (inEll(0.30, 0.18, 0.13, 0.16)) return true;
      if (inEll(0.50, 0.50, 0.18, 0.30)) return true;
      if (inEll(0.72, 0.65, 0.16, 0.28)) return true;
      if (inEll(0.78, 0.45, 0.10, 0.22)) return true;
      if (inEll(0.72, 0.18, 0.06, 0.15)) return true;
      return false;
    }
    var step = 0.018;
    for (var v = 0.05; v < 0.95; v += step) for (var u = 0.04; u < 0.96; u += step) if (inUS(u, v)) dotMap.push({ u: u, v: v });

    var hubs = [
      { name:'NYC', u:0.83, v:0.62, hi:true }, { name:'BOS', u:0.86, v:0.69, hi:false },
      { name:'DC',  u:0.82, v:0.55, hi:false }, { name:'ATL', u:0.69, v:0.32, hi:false },
      { name:'MIA', u:0.74, v:0.13, hi:true }, { name:'CHI', u:0.59, v:0.65, hi:true },
      { name:'DAL', u:0.42, v:0.25, hi:false }, { name:'HOU', u:0.43, v:0.18, hi:false },
      { name:'DEN', u:0.32, v:0.50, hi:false }, { name:'LAX', u:0.10, v:0.36, hi:true },
      { name:'SFO', u:0.06, v:0.55, hi:true }, { name:'SEA', u:0.13, v:0.85, hi:false },
      { name:'PDX', u:0.10, v:0.78, hi:false }, { name:'PHX', u:0.20, v:0.30, hi:false },
      { name:'MSP', u:0.50, v:0.78, hi:false }, { name:'STL', u:0.55, v:0.52, hi:false },
      { name:'NSH', u:0.62, v:0.42, hi:false }, { name:'CLT', u:0.74, v:0.40, hi:false },
      { name:'PHL', u:0.83, v:0.58, hi:false }, { name:'DET', u:0.65, v:0.70, hi:false }
    ];
    var you = { u: 0.72, v: 0.18 };
    function px(u, v) { var pad = 30; return { x: pad + u * (W - pad * 2), y: H - pad - v * (H - pad * 2) }; }

    var pulses = [];
    function spawnPulse() {
      var hub = hubs[Math.floor(Math.random() * hubs.length)];
      pulses.push({ from: you, to: hub, t: 0, dur: 1.4 + Math.random() * 0.8, hi: hub.hi });
    }

    var mNodes = document.getElementById('mNodes');
    var mLatency = document.getElementById('mLatency');
    var mQueue = document.getElementById('mQueue');
    var mLast = document.getElementById('mLast');
    var t = 0, lastSpawn = 0;
    function tick() {
      t += 0.016;
      ctx.fillStyle = 'rgba(6,8,16,0.22)'; ctx.fillRect(0, 0, W, H);

      for (var i = 0; i < dotMap.length; i++) {
        var d = dotMap[i]; var p = px(d.u, d.v);
        var alpha = 0.18 + Math.sin(t * 0.5 + i * 0.3) * 0.05;
        ctx.fillStyle = 'rgba(154,178,210,' + alpha + ')';
        ctx.beginPath(); ctx.arc(p.x, p.y, 0.9, 0, Math.PI * 2); ctx.fill();
      }

      var yp = px(you.u, you.v);
      var ringR = 16 + Math.sin(t * 2.4) * 5;
      ctx.strokeStyle = 'rgba(146,188,221,0.55)'; ctx.lineWidth = 1;
      ctx.beginPath(); ctx.arc(yp.x, yp.y, ringR, 0, Math.PI * 2); ctx.stroke();
      ctx.strokeStyle = 'rgba(146,188,221,0.22)';
      ctx.beginPath(); ctx.arc(yp.x, yp.y, ringR + 12, 0, Math.PI * 2); ctx.stroke();
      ctx.shadowColor = '#e0ecf7'; ctx.shadowBlur = 18;
      ctx.fillStyle = '#e0ecf7';
      ctx.beginPath(); ctx.arc(yp.x, yp.y, 4, 0, Math.PI * 2); ctx.fill();
      ctx.shadowBlur = 0;
      ctx.font = '9px JetBrains Mono, monospace';
      ctx.fillStyle = 'rgba(146,188,221,0.9)';
      ctx.fillText('YOU · BASE', yp.x + 12, yp.y - 8);

      ctx.strokeStyle = 'rgba(154,178,210,0.10)'; ctx.lineWidth = 0.5;
      for (var i = 0; i < hubs.length; i++) {
        var hp = px(hubs[i].u, hubs[i].v);
        ctx.beginPath(); ctx.moveTo(yp.x, yp.y); ctx.lineTo(hp.x, hp.y); ctx.stroke();
      }

      var nodeCount = 0;
      for (var i = 0; i < hubs.length; i++) {
        var hub = hubs[i]; var hp = px(hub.u, hub.v);
        var pulseAdd = Math.sin(t * 1.8 + i) * 0.5 + 0.5;
        if (hub.hi) {
          ctx.shadowColor = '#e0ecf7'; ctx.shadowBlur = 12;
          ctx.fillStyle = 'rgba(146,188,221,' + (0.7 + pulseAdd * 0.3) + ')';
        } else {
          ctx.shadowBlur = 0;
          ctx.fillStyle = 'rgba(154,178,210,0.55)';
        }
        ctx.beginPath(); ctx.arc(hp.x, hp.y, hub.hi ? 4 : 2.6, 0, Math.PI * 2); ctx.fill();
        ctx.shadowBlur = 0;
        if (hub.hi) {
          ctx.strokeStyle = 'rgba(146,188,221,0.4)'; ctx.lineWidth = 0.5;
          ctx.beginPath(); ctx.arc(hp.x, hp.y, 8 + Math.sin(t * 2 + i) * 2, 0, Math.PI * 2); ctx.stroke();
        }
        ctx.font = '8px JetBrains Mono, monospace';
        ctx.fillStyle = 'rgba(154,178,210,0.6)';
        ctx.fillText(hub.name, hp.x + 7, hp.y - 5);
        nodeCount++;
      }

      if (t - lastSpawn > 0.45) { spawnPulse(); lastSpawn = t; }
      for (var i = pulses.length - 1; i >= 0; i--) {
        var pl = pulses[i]; pl.t += 0.016;
        var k = pl.t / pl.dur;
        if (k >= 1) { pulses.splice(i, 1); continue; }
        var fp = px(pl.from.u, pl.from.v);
        var tp = px(pl.to.u, pl.to.v);
        var x = fp.x + (tp.x - fp.x) * k;
        var y = fp.y + (tp.y - fp.y) * k;
        ctx.strokeStyle = 'rgba(146,188,221,' + (1 - k) + ')'; ctx.lineWidth = 1.5;
        var tx = fp.x + (tp.x - fp.x) * Math.max(0, k - 0.18);
        var ty = fp.y + (tp.y - fp.y) * Math.max(0, k - 0.18);
        ctx.beginPath(); ctx.moveTo(tx, ty); ctx.lineTo(x, y); ctx.stroke();
        ctx.shadowColor = '#e0ecf7'; ctx.shadowBlur = 10;
        ctx.fillStyle = 'rgba(146,188,221,' + (1 - k * 0.6) + ')';
        ctx.beginPath(); ctx.arc(x, y, 3, 0, Math.PI * 2); ctx.fill();
        ctx.shadowBlur = 0;
      }

      if (mNodes) mNodes.textContent = nodeCount + ' / 160';
      if (mLatency) mLatency.textContent = (140 + Math.floor(Math.sin(t * 1.2) * 30 + Math.random() * 10)) + ' ms';
      if (mQueue) mQueue.textContent = (24 + Math.floor(Math.abs(Math.sin(t * 0.8) * 30) + Math.random() * 5));
      if (mLast) {
        var d = new Date();
        mLast.textContent = d.toLocaleTimeString('en-GB', { timeZone: 'America/Toronto', hour12: false });
      }
      requestAnimationFrame(tick);
    }
    tick();
  })();

  // ═══ Roster chips populate three rails ═══
  (function() {
    var chips1 = ['Google Business','Apple Maps','Yelp','Bing Places','Facebook','Foursquare','TripAdvisor','Waze','Nextdoor','BBB','Trustpilot','Yellow Pages','MapQuest','Yahoo Local'];
    var chips2 = ['Citysearch','Manta','Hotfrog','Brownbook','Insider Pages','Local.com','EZlocal','LocalStack','Cylex','Tupalo','MerchantCircle','iBegin','MojoPages','LocalDatabase'];
    var chips3 = ['Uber Eats','DoorDash','Grubhub','Zomato','OpenTable','Resy','Healthgrades','Vitals','Avvo','RateMDs','Glassdoor','Indeed','Angi','Thumbtack'];
    function buildRail(arr, gold) {
      var html = '';
      arr.forEach(function(c, i) {
        var goldCls = (gold && (i % 5 === 0)) ? ' roster__chip--gold' : '';
        html += '<div class="roster__chip' + goldCls + '"><span class="pip"></span>' + c + '</div>';
      });
      return html + html;
    }
    var r1 = document.getElementById('rail1'), r2 = document.getElementById('rail2'), r3 = document.getElementById('rail3');
    if (r1) r1.innerHTML = buildRail(chips1, true);
    if (r2) r2.innerHTML = buildRail(chips2, false);
    if (r3) r3.innerHTML = buildRail(chips3, true);
  })();

  // ═══ Case study canvas — 14 location pulses ═══
  (function() {
    var c = document.getElementById('caseCanvas');
    if (!c) return;
    var ctx = c.getContext('2d');
    var W = 0, H = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
    function resize() { var r = c.getBoundingClientRect(); W = r.width; H = r.height; c.width = W * dpr; c.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
    resize(); window.addEventListener('resize', resize);

    var locs = [];
    for (var i = 0; i < 14; i++) {
      locs.push({ x: 0.15 + (i % 5) * 0.18 + (Math.random() - 0.5) * 0.05, y: 0.25 + Math.floor(i / 5) * 0.22 + (Math.random() - 0.5) * 0.04, phase: Math.random() * Math.PI * 2 });
    }
    var t = 0;
    function tick() {
      t += 0.012;
      ctx.fillStyle = 'rgba(6,8,16,0.18)'; ctx.fillRect(0, 0, W, H);
      ctx.strokeStyle = 'rgba(154,178,210,0.06)'; ctx.lineWidth = 0.5;
      for (var i = 0; i <= 8; i++) {
        ctx.beginPath(); ctx.moveTo(0, H * i / 8); ctx.lineTo(W, H * i / 8); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(W * i / 8, 0); ctx.lineTo(W * i / 8, H); ctx.stroke();
      }
      for (var i = 0; i < locs.length; i++) {
        var l = locs[i]; var x = l.x * W, y = l.y * H;
        for (var k = 0; k < 3; k++) {
          var phase = (t * 1.5 + l.phase + k * 0.6) % 2;
          if (phase > 1.4) continue;
          var r = phase * 50;
          var a = (1 - phase / 1.4) * 0.4;
          ctx.strokeStyle = 'rgba(146,188,221,' + a + ')'; ctx.lineWidth = 0.8;
          ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.stroke();
        }
        ctx.shadowColor = '#e0ecf7'; ctx.shadowBlur = 10;
        ctx.fillStyle = '#e0ecf7';
        ctx.beginPath(); ctx.arc(x, y, 3, 0, Math.PI * 2); ctx.fill();
        ctx.shadowBlur = 0;
      }
      ctx.strokeStyle = 'rgba(154,178,210,0.10)'; ctx.lineWidth = 0.4;
      for (var i = 0; i < locs.length - 1; i++) {
        var a = locs[i], b = locs[i + 1];
        ctx.beginPath(); ctx.moveTo(a.x * W, a.y * H); ctx.lineTo(b.x * W, b.y * H); ctx.stroke();
      }
      requestAnimationFrame(tick);
    }
    tick();
  })();

  // ───────── Scroll reveals ─────────
  // Adds .is-in to .reveal / .reveal-stagger elements when they enter the
  // viewport, triggering the CSS fade-up + stagger transitions.
  (function(){
    if (!('IntersectionObserver' in window)) {
      // Fallback: just show everything
      document.querySelectorAll('.reveal, .reveal-stagger').forEach(function(el){
        el.classList.add('is-in');
      });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -8% 0px'
    });
    document.querySelectorAll('.reveal, .reveal-stagger').forEach(function(el){
      io.observe(el);
    });
  })();

  // ───────── Hero scroll-bloom + clock + live counters ─────────
  (function(){
    // Scroll-tied bloom: nodes spread outward 1.0× → 1.5× as you scroll the hero
    window.scrollBloom = 1;
    var hero = document.getElementById('spectraHero');
    function onScroll(){
      if (!hero) return;
      var h = hero.offsetHeight || window.innerHeight;
      var p = Math.max(0, Math.min(window.scrollY / h, 1));
      // Ease-out so most of the bloom happens early in the scroll
      var eased = 1 - Math.pow(1 - p, 2);
      window.scrollBloom = 1 + eased * 0.5;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Hero EST clock — same America/New_York timezone as nav clock
    var heroClock = document.getElementById('heroClock');
    function heroTick(){
      if (!heroClock) return;
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        hour12: false,
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      }).formatToParts(new Date());
      var h = '00', m = '00', s = '00';
      parts.forEach(function(p){
        if (p.type === 'hour')   h = p.value === '24' ? '00' : p.value;
        if (p.type === 'minute') m = p.value;
        if (p.type === 'second') s = p.value;
      });
      heroClock.textContent = h + ':' + m + ':' + s + ' EST';
    }
    heroTick(); setInterval(heroTick, 1000);

    // Live counters — count up from 0 to target on page load
    var counters = [
      { el: document.getElementById('hLiveListings'), target: 412938, dur: 2200 },
      { el: document.getElementById('hLiveSync'),     target: 184226, dur: 2200 },
      { el: document.getElementById('hLiveReviews'),  target:  73481, dur: 2400 }
    ];
    function fmt(n){ return Math.floor(n).toLocaleString('en-US'); }
    function easeOut(t){ return 1 - Math.pow(1 - t, 3); }
    counters.forEach(function(c){
      if (!c.el) return;
      var start = performance.now();
      function step(now){
        var p = Math.min((now - start) / c.dur, 1);
        c.el.textContent = fmt(c.target * easeOut(p));
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  })();

  // ───────── Hero "Sync Orbit" — orrery of 160 directories synced from one hub ─────────
  // The business is the bright hub at center; 160 directory nodes ride concentric
  // rings rotating at different speeds. A sync pulse keeps expanding out from the hub;
  // as it crosses each ring the nodes light up and STAY lit (synced). A handful of
  // real directories are labelled.
  (function(){
    var c = document.getElementById('heroCanvas');
    if (!c) return;
    var ctx = c.getContext('2d');
    var W = 0, H = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
    function resize(){ var r = c.getBoundingClientRect(); W = r.width; H = r.height; c.width = W*dpr; c.height = H*dpr; ctx.setTransform(dpr,0,0,dpr,0,0); }

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var NAMED = ['GOOGLE','APPLE MAPS','YELP','BING','FACEBOOK','TRIPADVISOR','FOURSQUARE','WAZE','NEXTDOOR','YELLOW PAGES'];
    var RING_DEF = [
      { rf: 0.18, count: 10, speed:  0.0016 },
      { rf: 0.32, count: 18, speed: -0.0012 },
      { rf: 0.47, count: 26, speed:  0.0009 },
      { rf: 0.63, count: 34, speed: -0.0007 },
      { rf: 0.80, count: 36, speed:  0.0005 },
      { rf: 1.00, count: 36, speed: -0.00038 }
    ];

    var rings = [], maxR = 0;
    function build(){
      maxR = Math.max(W, H) * 0.6;
      rings = [];
      var queue = NAMED.slice();
      for (var ri = 0; ri < RING_DEF.length; ri++){
        var def = RING_DEF[ri], nodes = [];
        for (var i = 0; i < def.count; i++){
          var ang = (i / def.count) * Math.PI * 2 + ri * 0.4;
          var name = null;
          if (ri >= 1 && ri <= 3 && queue.length && i % 3 === 0) name = queue.shift() || null;
          nodes.push({ ang: ang, flare: 0, synced: 0, tw: Math.random()*Math.PI*2, name: name });
        }
        rings.push({ r: def.rf * maxR, speed: def.speed, nodes: nodes });
      }
    }
    resize(); build();
    window.addEventListener('resize', function(){ resize(); build(); });

    var mx = 0, my = 0, tx = 0, ty = 0;
    document.addEventListener('mousemove', function(e){
      var r = c.getBoundingClientRect();
      tx = ((e.clientX - r.left)/W - 0.5) * 2;
      ty = ((e.clientY - r.top)/H - 0.5) * 2;
    });

    var t = 0, frame = 0;
    var pulse = { active: false, t: 0 };
    var PULSE_PERIOD = 230, PULSE_DUR = 150;

    function drawScene(animate){
      ctx.clearRect(0,0,W,H);
      mx += (tx - mx) * 0.05; my += (ty - my) * 0.05;
      var cx = W/2 + mx * W * 0.02;
      var cy = H/2 + my * H * 0.02;

      var bg = ctx.createRadialGradient(cx, cy, 0, cx, cy, maxR);
      bg.addColorStop(0, 'rgba(146,188,221,0.06)');
      bg.addColorStop(0.5, 'rgba(146,188,221,0.02)');
      bg.addColorStop(1, 'rgba(7,8,12,0)');
      ctx.fillStyle = bg; ctx.fillRect(0,0,W,H);

      for (var ri = 0; ri < rings.length; ri++){
        ctx.beginPath(); ctx.arc(cx, cy, rings[ri].r, 0, Math.PI*2);
        ctx.strokeStyle = 'rgba(146,188,221,0.07)'; ctx.lineWidth = 1; ctx.stroke();
      }

      var pulseR = -1;
      if (animate && pulse.active){
        pulse.t++;
        var pp = pulse.t / PULSE_DUR;
        pulseR = pp * maxR;
        var pa = Math.max(0, 1 - pp);
        ctx.save();
        ctx.globalCompositeOperation = 'lighter';
        ctx.beginPath(); ctx.arc(cx, cy, pulseR, 0, Math.PI*2);
        ctx.strokeStyle = 'rgba(255,238,200,' + (pa * 0.35) + ')';
        ctx.lineWidth = 6; ctx.stroke();
        ctx.restore();
        ctx.beginPath(); ctx.arc(cx, cy, pulseR, 0, Math.PI*2);
        ctx.strokeStyle = 'rgba(245,228,185,' + (pa * 0.9) + ')';
        ctx.lineWidth = 2; ctx.stroke();
        if (pulse.t >= PULSE_DUR) pulse.active = false;
      }

      for (var ri = 0; ri < rings.length; ri++){
        var ring = rings[ri];
        for (var i = 0; i < ring.nodes.length; i++){
          var n = ring.nodes[i];
          if (animate) n.ang += ring.speed;
          var px = cx + Math.cos(n.ang) * ring.r;
          var py = cy + Math.sin(n.ang) * ring.r;

          if (animate && pulseR >= 0 && Math.abs(pulseR - ring.r) < 14){ n.flare = 1; n.synced = 1; }
          if (n.flare > 0){ n.flare -= 0.02; if (n.flare < 0) n.flare = 0; }

          var tw = animate ? (0.45 + Math.sin(t*1.4 + n.tw) * 0.18) : 0.65;
          var alpha = Math.min(1, tw + n.synced * 0.5 + n.flare * 0.4);
          var rad = 1.3 + n.synced * 0.7 + n.flare * 1.8;

          if (n.flare > 0.02){
            ctx.beginPath(); ctx.moveTo(cx, cy); ctx.lineTo(px, py);
            ctx.strokeStyle = 'rgba(146,188,221,' + (n.flare * 0.4) + ')'; ctx.lineWidth = 0.8; ctx.stroke();
          }
          if (n.flare > 0.05){
            var g = ctx.createRadialGradient(px, py, 0, px, py, 10 + n.flare*8);
            g.addColorStop(0, 'rgba(235,217,168,' + (n.flare*0.5) + ')');
            g.addColorStop(1, 'rgba(235,217,168,0)');
            ctx.fillStyle = g; ctx.beginPath(); ctx.arc(px, py, 10 + n.flare*8, 0, Math.PI*2); ctx.fill();
          }

          ctx.fillStyle = 'rgba(' + ((n.synced || n.flare > 0.1) ? '240,224,178' : '255,245,212') + ',' + alpha + ')';
          ctx.beginPath(); ctx.arc(px, py, rad, 0, Math.PI*2); ctx.fill();

          if (n.name){
            var la = 0.30 + n.synced * 0.5 + n.flare * 0.4;
            ctx.font = '9px "JetBrains Mono", monospace';
            ctx.textBaseline = 'middle';
            ctx.textAlign = px >= cx ? 'left' : 'right';
            ctx.fillStyle = ((n.synced || n.flare > 0.1) ? 'rgba(235,217,168,' : 'rgba(159,163,170,') + Math.min(1, la) + ')';
            ctx.fillText(n.name, px + (px >= cx ? 8 : -8), py);
          }
        }
      }

      var hub = ctx.createRadialGradient(cx, cy, 0, cx, cy, 40);
      hub.addColorStop(0, 'rgba(235,217,168,0.5)');
      hub.addColorStop(0.4, 'rgba(146,188,221,0.18)');
      hub.addColorStop(1, 'rgba(146,188,221,0)');
      ctx.fillStyle = hub; ctx.beginPath(); ctx.arc(cx, cy, 40, 0, Math.PI*2); ctx.fill();
      ctx.fillStyle = 'rgba(245,235,205,0.95)'; ctx.beginPath(); ctx.arc(cx, cy, 3.2, 0, Math.PI*2); ctx.fill();
    }

    if (reduce){ drawScene(false); return; }

    function tick(){
      t += 0.016; frame++;
      if (frame % PULSE_PERIOD === 0){ pulse.active = true; pulse.t = 0; }
      drawScene(true);
      requestAnimationFrame(tick);
    }
    frame = PULSE_PERIOD - 40;
    tick();
  })();

/* approved layout: re-measure the hub graph when its box resizes, or it sits off-centre */
(function(){var n=document.querySelector('.section-spectra-network');if(!n||!window.ResizeObserver)return;var t;new ResizeObserver(function(){clearTimeout(t);t=setTimeout(function(){window.dispatchEvent(new Event('resize'));},120);}).observe(n);})();

}
